export enum FileUploadStatusEnum {
    UPLOADING = 'uploading',
    DONE = 'done',
    ERROR = 'error',
}
